import { useLocalStorage } from '@client/hooks/use-local-storage';
import { useAsideWidthContext } from '@contexts/AsideWidth';
import { useCallback } from 'react';

export const useResizer = (defaultWidth, initialWidth) => {
  const [storageWidth, setStorageWidth] = useLocalStorage('asideWidth', defaultWidth, initialWidth);
  const { setAsideWidth } = useAsideWidthContext();
  const setAsideWidthStorage = useCallback(
    (event, { size }) => {
      setStorageWidth(size?.width);
    },
    [setStorageWidth]
  );

  const onResize = useCallback(
    (event, { size }) => {
      setAsideWidth(size.width);
    },
    [setAsideWidth]
  );
  return {
    storageWidth,
    setAsideWidthStorage,
    onResize,
  };
};
